export default "__VITE_ASSET__BU9$B4KF__"